<nav class="navbar fixed-top" id="header">
  @if (!showHeaders) {
    <a href="/" class="navbar-brand">
      <img src="assets-front/images/logo-clea.png" class="d-none d-lg-inline">
    </a>
  }
  @if (showHeaders) {
    <a routerLink="/" class="navbar-brand" data-intro="logo">
      <img src="assets-front/images/logo-clea.png" class="d-none d-lg-inline">
      @if (logoUrl) {
        <span class="d-none d-lg-inline ms-2 me-2 color-blue"> </span>
        <img src="{{ logoUrl }}" class="d-none d-lg-inline partnerLogoImage">
      }
      <img src="assets-front/images/logo-clea-mobile.svg" class="d-lg-none">
      @if (logoUrl) {
        <span class="d-lg-none ms-3 me-2 color-blue"> </span>
        <img src="{{ logoUrl }}" class="d-lg-none">
      }
      @if (envName && envName !== '') {
        <span class="envName">{{ envName }}</span>
      }
    </a>
  }
  @if (showHeaders) {
    <div>
      @if (isMCS && !previsualisation) {
        <a id="espace-mcs" href="/pro/dashboard" class="btn">
          <img src="assets-front/pictos/picto-carnet-generique.svg"/>
          <span>Conseil syndical</span>
        </a>
      }
      @if (!previsualisation) {
        <a routerLink="/mes-logements" class="btn" data-intro="logements" >
          <img src="assets-front/pictos/picto-carnet.svg"/>
          <span>Mes logements</span>
        </a>
      }
      @if (!previsualisation) {
        <button type="button" class="btn" routerLink="/notifications" data-intro="notifications">
          <img src="assets-front/pictos/picto-cloche.svg" class="picto-menu">
          <span>Notifications</span>
          @if (notificationsCount | async; as count) {
            <span class="badge-notif">{{count}}</span>
          }
        </button>
      }
      <button type="button" class="menu-toggler btn" (click)="toggleMenu();" data-intro="menu">
        <img src="assets-front/pictos/picto-liste.svg"/>
        <span>Menu</span>
      </button>
    </div>
  }
</nav>
